export default __webpack_public_path__ + "assets/clipboard.32e7d0f0.svg";